import { ArrowBackOutlined, MoreHorizOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react'
import { font } from '../../../styles/font';
import GraphComponent from './GraphComponent';
import { CounterTableComponent } from '..';

export default function GraphPreview({ data, onClose }) {

    const handleClose = () => {
        onClose();
    }


    return (
        <Box className=" flex flex-col gap-0 w-full h-full">
            <Box className="flex items-center justify-between gap-2 px-4 py-2 border-b">
                <IconButton onClick={handleClose}>
                    <ArrowBackOutlined />
                </IconButton>
                <Typography fontSize={font.size.fs_5} color="textSecondary" className="flex-1  ">{data?.title}</Typography>

                <IconButton>
                    <MoreHorizOutlined />
                </IconButton>
            </Box>

            <Box className="flex-1 flex flex-col  gap-0 overflow-auto">
                <Box className="flex-1 flex flex-col gap-2 px-0 py-0 overflow-auto   ">
                    <GraphComponent title={data?.title} data={data?.data} style={{ width: "auto", height: "100%" }} />
                </Box>

                <Box className="flex-1 flex-col gap-2 px-4 py-2  h-full w-full ">
                    <CounterTableComponent data={data.tableList} />
                </Box>
            </Box>

        </Box>
    )
}
